import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 4a2.988 2.988 0 0 0-2.61 1.551l-4.409-.735C9.883 2.146 7.694 0 5 0 2.243 0 0 2.243 0 5s2.243 5 5 5c.384 0 .754-.053 1.113-.135l1.382 3.041C6.591 13.641 6 14.747 6 16c0 2.206 1.794 4 4 4s4-1.794 4-4c0-.918-.322-1.754-.844-2.429l2.906-3.736c.296.099.608.165.938.165 1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-7 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM7.931 9.031A5 5 0 0 0 9.654 6.79l4.399.732c.07.397.217.765.426 1.091l-2.893 3.718A3.974 3.974 0 0 0 10 12c-.236 0-.464.03-.688.069L7.931 9.031zM2 5c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3z"
});

var SvgTeamMajorMonotone = function SvgTeamMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgTeamMajorMonotone as S };